import { useEffect, useState } from 'react';

import { getSecondsDifference } from 'App/Helpers';

/**
 * Hook checks the game loading time and sends it along with analytics events to track loading performance
 *
 * @param isLoaded - boolean
 * @param {Function} sendGameDesignEvent - Deferred GameAnalytics design event.
 * @param {Function} sendGoogleBasicEvent - Deferred Google Analytics basic event.
 */
export const useGameLoadingTime = ({
    isLoaded,
    sendGameDesignEvent,
    sendGoogleBasicEvent,
}) => {
    const [startLoadingTime, setStartLoadingTime] = useState(null);

    useEffect(() => {
        setStartLoadingTime(performance.now());
    }, []);

    useEffect(() => {
        if (isLoaded) {
            const loadingTime = getSecondsDifference(
                startLoadingTime,
                performance.now()
            );

            sendGameDesignEvent('Game:LoadingTimeOnFront', loadingTime);
            sendGoogleBasicEvent('game', 'loading_time_on_front', loadingTime);
        }
    }, [isLoaded]);
};
